import React from 'react'
import cx from 'classnames'

import styles from './MenuItem.module.scss'

type MenuItemProps = {
  children?: React.ReactNode
  className?: string
  isActive?: boolean
}

export const MenuItem = ({
  children,
  className,
  isActive = false,
}: MenuItemProps) => (
  <li
    className={cx(
      styles.item,
      {
        [styles.active]: isActive,
      },
      className,
    )}
  >
    {children}
  </li>
)
